<template>
  <div id="deviceready">
    <div id="cameraAndPicture" v-if="currentMedia===''">
      <canvas class="raster" id="fullsize"></canvas>
      <canvas class="raster" id="thumbnail"></canvas>
      <div class="actions">
        <font-awesome-icon color="#00d6ff" id="switch" size="lg" class="" @click="onSwitch" icon="exchange-alt"
                           v-if="['mobile','tablet']"/>
        <!--        <div class="action torch" id="torch">Torch</div>-->
        <!--        <font-awesome-icon color="#00d6ff" id="scan" size="lg" class="" icon="qrcode"/>-->
      </div>
    </div>
    <CameraControls v-if="streamingCanvas && currentMedia === ''" :streamingCanvas="streamingCanvas"
                    :saveMedia="saveMedia"/>
    <SavePicture v-if="currentMedia !== ''" :url="currentMedia" :removeMedia="removeMedia"/>
  </div>

</template>

<script>
import CameraControls from "../../Camera/Controls/CameraControls";
import {store} from '../../../store/store';

import SavePicture from "../../Camera/Widgets/SavePicture";
import {mapState, mapActions} from "vuex";


export default {
  name: 'ScanView',
  components: {
    CameraControls,
    SavePicture,
  },
  data() {
    return {
      store,
      streamingCanvas: null,
      media: '',
      camera: "auto",
      qrcode_uid: this.$route.params.qrcode_uid,
    }
  },
  computed: {
    ...mapState([
      "user",
      "masks",
      "logged",
      "currentMedia"
    ])
  },
  mounted() {
    // !this.user && this.$router.push({ name: "landingPage",qrcode_uid:this.qrcode_uid });
    const MaskCanvas = document.getElementsByClassName('jeeFaceFilterCanvas');

    if (MaskCanvas.length) {
      MaskCanvas[0].style.display = "block";
      this.streamingCanvas = MaskCanvas[0];
    } else {
      const canvas = document.createElement('canvas');
      canvas.id = 'jeeFaceFilterCanvas';
      canvas.className = 'jeeFaceFilterCanvas';
      canvas.ref = "mainCanvas";
      canvas.width = document.body.clientWidth;
      canvas.height = document.body.clientHeight;
      canvas.style.transform = "translate(0, 0) rotateY(180deg)";
      canvas.style.position = "absolute";
      canvas.style.zIndex = "-1";
      canvas.style.opacity = "1";

      document.querySelector('#deviceready').appendChild(canvas);
      this.streamingCanvas = canvas;
    }
    main()
    resetCamera()

    setTimeout(this.loadMask, 2000)


  },
  destroyed() {
    closeCamera()
  },
  methods: {
    ...mapActions([
      'getMask'
    ]),
    deviceCheck(arrayValue) {
      let device = getDevice()
      return arrayValue.includes(device)
    },
    loadMask() {
      //getMask => scanMask
      this.getMask(this.qrcode_uid).then(res => {

        if (res.successList) {
          store.state.successBase = res.successList.filter(function (el) {
            return el.condition === null
          })
          store.state.success = res.successList.filter(function (el) {
            return el.condition != null
          })

        }
        let maskObject = res.value.mask.objet.length > 0 ? res.value.mask.objet : res.value.mask.name.toLowerCase();
        load_mask(maskObject, res.value.image_texture)
      })
    },
    onSwitch() {
      onSwitch()
    },
    saveMedia(media) {
      store.state.currentMedia = media
    },
    removeMedia() {
      this.media = '';
      const preview = document.getElementById("mediaPreview");
      preview.parentNode.removeChild(preview);
    },
    async onDecode(decodeString) {
      document.location.href = decodeString.rawValue
    },
    timeout(ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    paintCenterText(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {boundingBox, rawValue} = detectedCode
        const centerX = (boundingBox.width - boundingBox.x) / 2
        const centerY = boundingBox.y
        const fontSize = Math.max(12, 50 * boundingBox.width / ctx.canvas.width)
        ctx.font = `bold ${fontSize}px sans-serif`
        /* ctx.textAlign = "center"
         ctx.lineWidth = 3
         ctx.strokeStyle = '#35495e'
         ctx.strokeText(detectedCode.rawValue, centerX, centerY)
         ctx.fillStyle = '#5cb984'
         ctx.fillText(rawValue, centerX, centerY)*/
        let img = new Image();   // Crée un nouvel élément Image
        img.src = './assets/logo.png';

        ctx.drawImage(img, centerX, centerY, boundingBox.height * 2, boundingBox.width * 2)
        this.onDecode(detectedCode)
      }
    },
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {boundingBox: {x, y, width, height}} = detectedCode
        ctx.lineWidth = 4
        ctx.strokeStyle = '#2381ef'
        ctx.strokeRect(x, y, width, height)
      }
      this.paintCenterText(detectedCodes, ctx)
    },
  }
}
</script>

<style scoped>
.home h1 {
  color: #1067AC;
  font-weight: bold;
}

#mediaPreview {
  width: 100vw;
}

body {
  background-color: #000;
}

#deviceready {
  height: 100%;
}

#openMouthInstruction {
  display: none;
}


.image > img {
  width: 100%;
}

.gallery > * {
  margin: 4px;
}


@media screen and (min-aspect-ratio: 1/1) and (min-width: 400px) {
  .app {

  }
}

/* Canvas */
canvas.raster {
  top: 0;
  left: 0;
  position: absolute;
}

/* Actions */
.actions {
  padding: 4px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 5px;
  position: fixed;
}

.actions svg {
  width: 1.8em;
  height: 1.8em;
}

.actions > * {
  margin: 10px 0px;
}

div.action {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  position: relative;
}

@media screen and (max-width: 750px) {
  .actions {
    top: env(safe-area-inset-top);
  }
}


.qrcode-stream-camera {
  transform: translate(0, 0) rotateY(180deg);
}


</style>
